

import React, { useEffect, useState } from "react";
import { BrowserRouter as Router} from 'react-router-dom';
import { Provider } from 'react-redux';
import { MantineProvider } from '@mantine/core';
import { getAuthorizationToken } from "./helpers/storagehelper";
import { ContextProvider } from "./Contexts/ContextProvider";
import { Notifications } from '@mantine/notifications';
import OverlayLoader from "./components/mantine/overlayloader";
import store from "./store";
import Routing from '../src/routes'; 

const App = () => {
  const [navbar, SetNavBar] = useState(null);

  useEffect(() => {
    SetNavBar(getAuthorizationToken());
  }, [getAuthorizationToken()]);

  return (
    <Router>
      <Provider store={store}>
        <MantineProvider>
          <ContextProvider>
            <Notifications position="top-right" zIndex={1000} />
            <OverlayLoader />
            <meta name="referrer" content="no-referrer" />
            <Routing /> 
          </ContextProvider>
        </MantineProvider>
      </Provider>
    </Router>
  );
};

export default App;